import React from "react"
import { Spring } from "react-spring/renderprops"

import { slideInSpringProps } from "../services/helpers"
import useWindowDimensions from "../hooks/useWindowDimensions.js"
import VisibilitySensor from "./visibility-sensor"

const AnimatedSection = ({
  className,
  leftElement,
  rightElement,
  inverted,
}) => {
  const { isMobile } = useWindowDimensions()
  const firstFromLeft = !inverted || (inverted && isMobile)
  const secondFromLeft = inverted && !isMobile
  return (
    <section className={className}>
      <div className="inner grid grid-section">
        <VisibilitySensor once partialVisibility>
          {({ isVisible }) => (
            <Spring {...slideInSpringProps(isVisible, 300, !firstFromLeft)}>
              {props => (
                <div
                  className={`centered-grid-element ${
                    inverted ? "col-last" : 0
                  }`}
                  style={{ ...props }}
                >
                  {leftElement}
                </div>
              )}
            </Spring>
          )}
        </VisibilitySensor>
        <VisibilitySensor once partialVisibility>
          {({ isVisible }) => (
            <Spring {...slideInSpringProps(isVisible, 300, !secondFromLeft)}>
              {props => (
                <div className="centered-grid-element" style={{ ...props }}>
                  {rightElement}
                </div>
              )}
            </Spring>
          )}
        </VisibilitySensor>
      </div>
    </section>
  )
}

export default AnimatedSection
